/**
 * Interval with Timeout allows you to evaluate
 * a validation callback on a specified interval and will
 * resolve as either "true" given the callback
 * function returns true or "false" if the timeout
 * duration as been reached.
 *
 * @param {() => boolean} validation function
 * @param {number} interval in in milliseconds that the validation
 *                 function should be run.
 * @param {number} timeout in milliseconds
 * @returns Promise<boolean> If the validation has succeeded
 *
 * @example
 * intervalWithTimeout(() => !!window.QSI, 100, 10000);
 */
export function intervalWithTimeout(
  validation: () => boolean,
  interval: number,
  timeout: number,
): Promise<boolean> {
  return new Promise(resolve => {
    let timeoutId: number | null = null;
    let intervalId: number | null = null;

    // Start the interval
    intervalId = window.setInterval(() => {
      if (validation()) {
        if (intervalId !== null) { clearInterval(intervalId); } // Stop the interval
        if (timeoutId !== null) { clearTimeout(timeoutId); } // Stop the timeout
        resolve(true);
      }
    }, interval);

    // Start the timeout
    timeoutId = window.setTimeout(() => {
      if (intervalId !== null) { clearInterval(intervalId); } // Stop the interval when timeout is reached
      resolve(false);
    }, timeout);
  });
}
